import { Celebration } from "@mui/icons-material"
import { SubtypeToolboxPlaceholderScaffold } from "../../../pages/actionModules/ActionModuleEditor/SubtypeEditor/SubtypeToolbox";
import { PropertyTypes } from "../editor/subtypeEditorTypes";
import { SubtypeDefinition } from "../actionModule";
import { Subtype } from "./subtype";
import AnniversaryBonusEditorPreview from "../../../components/actionModules/subtypes/anniversaryBonus/AnniversaryBonusEditorPreview";

export const AnniversaryBonusSubtype: SubtypeDefinition =
{
    name: "actionModules.subtypes.anniversaryBonus.name",
    type: Subtype.AnniversaryBonusModuleSubtype,
    icon: <Celebration />,
    toolboxPlaceholder: () => <SubtypeToolboxPlaceholderScaffold
        icon={<Celebration />}
        name="actionModules.subtypes.anniversaryBonus.name" />,
    editorPreview: AnniversaryBonusEditorPreview,
    editableProperties: [
        {
            displayName: "actionModules.subtypes.anniversaryBonus.celebratedAnniversaries",
            name: "celebratedAnniversaries",
            defaultValue: [5, 10, 15, 20, 25, 30],
            propertyType: PropertyTypes.complex
        },
        {
            displayName: "actionModules.subtypes.anniversaryBonus.bonusReward",
            name: "bonusRewardPoints",
            propertyType: PropertyTypes.integer,
            defaultValue: 600,
        }
    ]
};